import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { otherTopics } from "@/lib/topics";

/**
 * "Explore other topics" grid shown at the bottom of every detail page.
 * Uses the same visual language as the main Intelligence cards on home.
 */
export default function TopicNav({ currentSlug }) {
  const rest = otherTopics(currentSlug);

  return (
    <section className="relative py-24 md:py-28 bg-[#050505] text-white" data-testid="topic-nav">
      <div className="absolute inset-0 btr-grid opacity-25 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4">
          <div>
            <span className="btr-badge">
              <span className="dot" />
              Explore Other Topics
            </span>
            <h3 className="font-display font-extrabold text-white text-3xl sm:text-4xl mt-5 leading-tight tracking-tight">
              Continue your <span className="text-[#a2020b]">risk intelligence</span> briefing.
            </h3>
          </div>
          <Link
            to="/services"
            className="text-[11px] font-display tracking-[0.25em] uppercase text-zinc-400 hover:text-[#a2020b] transition-colors inline-flex items-center gap-2"
          >
            All services <ArrowUpRight className="w-3.5 h-3.5" />
          </Link>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 mt-10">
          {rest.map((t, i) => (
            <Link
              key={t.slug}
              to={`/topics/${t.slug}`}
              className="btr-reveal group relative aspect-[4/5] rounded-xl overflow-hidden border border-white/10 hover:border-[#a2020b]/60 transition-colors"
              style={{ transitionDelay: `${i * 60}ms` }}
              data-testid={`topic-nav-card-${t.slug}`}
            >
              <img
                src={t.image}
                alt={t.title}
                loading="lazy"
                decoding="async"
                width="800"
                height="640"
                className="absolute inset-0 w-full h-full object-cover grayscale-[0.3] transition-transform duration-[1200ms] group-hover:scale-[1.08]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/60 to-transparent" />
              <div className="absolute inset-0 bg-[radial-gradient(circle_at_80%_10%,rgba(162,2,11,0.5),transparent_60%)] mix-blend-screen opacity-70 group-hover:opacity-100 transition-opacity" />

              <div className="absolute top-3 left-3 w-8 h-8 border-t border-l border-[#a2020b]/70" />
              <div className="absolute bottom-3 right-3 w-8 h-8 border-b border-r border-[#a2020b]/70" />

              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="text-[10px] font-display tracking-[0.3em] uppercase text-[#a2020b]">
                  {t.number} / 06
                </div>
                <div className="font-display font-bold text-white text-lg mt-1">{t.title}</div>
                <div className="flex items-center justify-between mt-1">
                  <div className="font-body text-zinc-300 text-xs">{t.tag}</div>
                  <ArrowUpRight className="w-4 h-4 text-[#a2020b] transition-transform group-hover:translate-x-1 group-hover:-translate-y-1" />
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
